module.exports = __webpack_public_path__ + "static/media/iStock-1277551965.2605bdc3.jpg";